
    import Vue from 'vue';
    import AppPoweredBy from '@/components/Layout/AppPoweredBy.vue';
    import { settingsHelper } from '@/store/modules/settings';
    const settingsHelpers = settingsHelper.mapGetters({footer: 'footer' });
    
    export default Vue.extend({
        name: 'AppFooter',
        components: {
            AppPoweredBy,
        },
        computed: {
            ...settingsHelpers,
            noFooter() {
              try {
                return this.$store.state.settings.config.app.noFooter;
              } catch (error) {
                return false;
              }
            },
            overrideLogo(): string | undefined {
                return this.footer && this.footer.logo;
            },
            noLogo(): boolean {
                return (this.footer !=undefined && this.footer.logo !=undefined && this.footer.logo == " ");
            },
            text(): string {
                return (
                    (this.footer && this.footer.text) ||
                    'Consents Online Ltd is authorised and regulated by the Financial Conduct Authority under Firm Reference Number: FRN 792642'
                );
            },
        },
    });
